<div data-testid="scenarios-trend" class="scenarios-trend">
  <header class="scenarios-trend__header">
    <div class="scenarios-trend__titles">
      <h4 class="scenarios-trend__title">{{ cardTitle }}</h4>
      <p class="scenarios-trend__description">{{ description }}</p>
      <p *ngIf="numbersText" data-testid="scenarios-trend-numbers" class="scenarios-trend__numbers">{{ numbersText }}</p>
    </div>
  </header>
  <app-admin-dashboard-empty *ngIf="failed" data-testid="scenarios-trend-failed" icon="fa-regular fa-circle-exclamation"
                             [title]="failedTitle" body="Try again, or change the filters." [compact]="true"></app-admin-dashboard-empty>
  <app-admin-dashboard-empty *ngIf="loaded && !failed && isEmpty" data-testid="scenarios-trend-empty" icon="fa-regular fa-table-cells"
                             [title]="emptyTitle"></app-admin-dashboard-empty>
  <div *ngIf="loaded && !failed && !isEmpty" #chart data-testid="scenarios-trend-chart" class="scenarios-trend__chart"></div>
  <div *ngIf="!loaded" class="scenarios-trend__chart"></div>
  <ng-container *ngIf="loaded && !failed && !isEmpty">
    <p *ngFor="let note of notes" data-testid="scenarios-trend-note" class="scenarios-trend__note">{{ note }}</p>
  </ng-container>
</div>
